/**
 * Enum for DebitOrCreditEnum
 *
 * DATEV convention: "S" = Soll (debit), "H" = Haben (credit)
 */
export enum DebitOrCreditEnum {
  "DEBIT" = "S",
  "CREDIT" = "H"
}
